import React from 'react';

const ChartLegend = ({ title }) => {
  return (
    <div style={{ marginTop: '10px', textAlign: 'center' }}>
      <label style={{ color: '#000', fontFamily: 'Quicksand' }}>
        {title}
      </label>
    </div>
  );
};

export default ChartLegend;
